/**
 * @file LeftLoginView.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import React from "react";
import Paper from "@mui/material/Paper";
import { Stack } from "@mui/material";
import { Img } from "../../common/customviews/AppImg";

/**
 * A method definition for LeftLoginView
 */
export default function LeftLoginView() {
    return (
        <Paper
            component={Stack} elevation={0} direction={"column"}
            sx={{
                p: 2,
                margin: "auto",
                maxWidth: 500,
                flexGrow: 1,
                border: "0px",
                alignItems: "center",
                overflow: "hidden",
                backgroundColor: (theme) =>
                    theme.palette.mode === "dark" ? "#1A2027" : "#F4F5F6",
            }}>
            <Img alt="complex" src="/../home_icon.svg" />

        </Paper>
    );
}